import home from '../../api/home'

// User store
// Handles storage and management of user profiles
export default {
  namespaced: true,
  state: {
    loading: false,
    email: null,
    address: null,
    business_name: null,
    city: null,
    country: null,
    full_name: null,
    phone: null,
    postcode: null,
    website: null,
    job_title: null
  },
  getters: {
    getLoading: state => {
      return state.loading
    },
    getUser: state => {
      return {
        email: state.email,
        address: state.address,
        business_name: state.business_name,
        city: state.city,
        country: state.country,
        full_name: state.full_name,
        phone: state.phone,
        postcode: state.postcode,
        website: state.website,
        job_title: state.job_title
      }
    }
  },
  mutations: {
    updateUser (state, user) {
      state.email = user.email
      state.address = user.address
      state.business_name = user.business_name
      state.city = user.city
      state.country = user.country
      state.full_name = user.full_name
      state.phone = user.phone
      state.postcode = user.postcode
      state.website = user.website
      state.job_title = user.job_title
    },
    setLoading (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    get ({commit}) {
      commit('setLoading', true)
      home.getUserProfile(
        response => {
          commit('setLoading', false)
          commit('updateUser', response)
        },
        error => {
          commit('setLoading', false)
          console.log('Could not get user', error)
        }
      )
    },
    set ({commit}, params) {
      commit('updateUser', params)
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        home.updateUserProfile(params,
          response => {
            commit('setLoading', false)
            resolve()
          },
          error => {
            commit('setLoading', false)
            reject(error)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js